import { Component, Inject, NgZone, OnInit, PLATFORM_ID  } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CartService } from './shared/services/cart.service';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { CurrencyService } from './shared/services/currency.service';
import { filter, first } from 'rxjs/operators';
import { AuthService, ShopService } from './shared/services';
import { DirectionService } from './shared/services/direction.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private router: Router,
        private toastr: ToastrService,
        private cart: CartService,
        private zone: NgZone,
        private scroller: ViewportScroller,
        private currency: CurrencyService,
        private authService: AuthService,
        private direction: DirectionService,
    ) {
        const detectedDirection = 'rtl';

        this.direction.value = detectedDirection;
        if (isPlatformBrowser(this.platformId)) {

            this.zone.runOutsideAngular(() => {
                this.router.events.pipe(filter(event => event instanceof NavigationEnd), first()).subscribe(() => {
                    const preloader = document.querySelector('.site-preloader');

                    preloader.addEventListener('transitionend', (event: TransitionEvent) => {
                        if (event.propertyName === 'opacity') {
                            preloader.remove();
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                });
            });
        }
    }

    async ngOnInit() {
        this.authService.autoAuthUser()
        var baseurl = window.location.origin;
        // properties of the CurrencyFormatOptions interface fully complies
        // with the arguments of the built-in pipe "currency"
        // https://angular.io/api/common/CurrencyPipe
        this.currency.options = {
           // code: 'PKR',
            code: 'USD',
            // display: 'symbol',
            digitsInfo: '1.0-0',
             locale: 'en-US'
        };
        this.router.events.subscribe((event) => {
            if ((event instanceof NavigationEnd)) {
                this.scroller.scrollToPosition([0, 0]);
                const canonicalUrl =baseurl+event.urlAfterRedirects;
                this.setCanonicalTag(canonicalUrl);
            }
        });
        this.cart.onAdding$.subscribe(product => {
            this.toastr.success(`Product "${product.name}" added to cart!`);
        });
    }
    setCanonicalTag(url: string): void {
        const existingLink = document.querySelector('link[rel="canonical"]');
        if (existingLink) {
          existingLink.setAttribute('href', url);
        } else {
            var link = document.createElement('link');
            link.setAttribute('rel', 'canonical');
            link.setAttribute('href', url);
            document.head.appendChild(link);
        }
    }
}
declare var $: any;